module.exports = __webpack_public_path__ + "static/img/far3_active.e9bf959e.png";